<div class="usan-form-item molecular-formula-file-container">
  <div class="usan-checklist-item">
    <div class="usan-checklist-icon-column">
      <mat-icon>{{ hasMolecularFormulaFile ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </div>
    <div class="usan-checklist-content-column">
      <span class="usan-form-item molecular-formula-file-item molecular-formula-file-text">
        Molecular Formula definition file(s) if not entered above
      </span>
    </div>
  </div>
  <div class="usan-form-item button-layout layout-centered">
    <button type="button" class="upload-molecular-formula-file form-btn form-btn-style form-btn-text"
      (click)="openDialog()">
      <mat-icon class="form-btn-icon">upload</mat-icon>
      Upload Molecular Formula
    </button>
  </div>
  <ng-container *ngIf="hasMolecularFormulaFile">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>